<template>
  <div>
    <CatalogosEdit
      :item="currentItem"
      :update="updateItem"      
      :close="closeEdit"
      :descSingular="descSingular"
    ></CatalogosEdit>
          <Loading :isActive="loading"></Loading>
          <CTabs variant="tabs" class="nav-tabs-boxed">
            <CTab :title=" descPlural ">
              <CatalogosTable :items="items" :openEdit="openEdit" :openCreate="openCreate" :deleteConfirm="deleteConfirm"/>
            </CTab>
          </CTabs>
  </div>
</template>
<script>
import clone from 'just-clone';
import { get, post, put, del } from '@/helpers/apiRequest';
import CatalogosEdit from './components/CatalogosEdit';
import CatalogosTable from './components/CatalogosTable';
import _filter      from 'lodash/filter';
import jsonFormData from 'json-form-data';

const ItemCatalogo = {
  id          : null,
  imagem_capa : null,
  descricao   : null,
  ordem       : 1,
  url         : null,
  ativo       : null,
  arquivo     : null,
  arquivo_nome: null,
}

export default {
  name: 'catalogos',
  components: {
    CatalogosEdit,
    CatalogosTable,
  },
  data() {
    return {
      descPlural   : '',
      descSingular : '',
      loading      : false,
      items        : [],
      modulos      : [],
      currentItem  : {},
      currentAccess: false,
      paginas      : [],
      secoes       : []
    };
  },
  methods: {
    loadDescricaoModulo() {
      const { modulos } = JSON.parse(localStorage.getItem('app'));
      const { descPlural, descSingular } = modulos.find(
        (m) => m.nome === 'ADMIN_CATALOGO'
      );
      this.descPlural = descPlural;
      this.descSingular = descSingular;
    },
    loadCatalogos() {
      this.loading = true;
      get('/admin/site-catalogos')
        .then((json) => {
          this.items   = json;
          this.loading     = false;
        })
        .catch(() => (this.loading = false));
    },
    openCreate() {
      this.currentItem = clone(ItemCatalogo);
      this.$modal.show('catalogoEdit');
    },
    closeCreate() {
      this.$modal.hide('catalogoEdit');
    },
    openEdit(item) {
      item.arquivo     = null;
      this.currentItem = clone(item);
      this.loading     = false;
      this.$modal.show('catalogoEdit');
    },
    closeEdit() {
      this.$modal.hide('catalogoEdit');
    },
    doRequest() {
      const options = {
        initialFormData: new FormData(),
        showLeafArrayIndexes: true
      };
      const formDataItems = jsonFormData(this.currentItem, options);
      return this.currentItem.id ?
      post(`/admin/site-catalogos/${this.currentItem.id}`, formDataItems, {isFile: true})
      :
      post('/admin/site-catalogos', formDataItems, {isFile: true});
    },
    updateItem() {
      this.doRequest()
        .then((json) => {
          this.closeEdit();
          this.loadCatalogos();
          this.$swal({
            title: 'Salvo com sucesso',
            text: json.message,
            showCancelButton: false,
            cancelButtonText: 'Fechar',
            showConfirmButton: true,
            icon: 'success',
          });          
        })
        .catch((error) => {
          this.$swal({
            title: 'Falha ao Salvar',
            text: error.message,
            showCancelButton: true,
            cancelButtonText: 'Fechar',
            showConfirmButton: false,
            icon: 'error',
          });
        });
    },
    deleteConfirm(id) {
      this.$swal({
        title: 'Confirma Remover ?',
        text: 'Essa ação não poderá ser desfeita',
        showCancelButton: true,
        icon: 'warning',
        confirmButtonText: 'Excluir',
        cancelButtonText: 'Cancelar',
      })
        .then((res) => {
          if (res.value) {
            this.loading = true;
            del(`/admin/site-catalogos/${id}`)
              .then((json) => {
                this.loading = false;
                this.$swal({
                  title: 'Removido com sucesso',
                  icon: 'success',
                });
                this.loadCatalogos();
              })
              .catch((err) => {
                this.loading = false;
                this.$swal({
                  title: 'Falha ao remover',
                  icon: 'error',
                });
              });
          }
        })
        .catch(() => {});
    },    
  },
  beforeMount() {
    this.loading = true;
    this.loadCatalogos();
    this.loadDescricaoModulo();
  },
};
</script>
